import React, { ReactNode, useContext, useEffect } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { matchRoutes } from "react-router-config";
import qs from "qs";
import AppContext from "./AppContext";
import { useAuthToken } from "./AppHooks";
import { Loader } from "../index";
import { checkPermission } from "./Utils";
import { initialUrl } from "../../shared/constants/AppConst";
import AppContextPropsType from "../../types/AppContextPropsType";
import { NavStyle, ThemeMode, ThemeStyle } from "../../shared/constants/AppEnums";

interface AuthRoutesProps {
  children: ReactNode;
}

const AuthRoutes: React.FC<AuthRoutesProps> = ({children}) => {
  const {pathname, search} = useLocation();
  const history = useHistory();
  const {
    routes,
    changeNavStyle,
    updateThemeStyle,
    initialPath,
    setInitialPath,
    updateThemeMode,
    setRTL,
  } = useContext<AppContextPropsType>(AppContext);

  const [loading, user] = useAuthToken();
  const currentRoute = matchRoutes(routes, pathname)[0].route;
  let isPermitted = checkPermission(currentRoute.auth, user ? user.role : null);

  useEffect(() => {
    function setInitPath() {
      if (
        initialPath === '/' &&
        [
          
          '/login',
          '/reset-password',
          '/error-pages/error-404',
          '/forget-password',
        ].indexOf(pathname) === -1
      ) {
        if (isPermitted) {
          setInitialPath(pathname);
        } else {
          setInitialPath(undefined);
        }
      }
    }

    setInitPath();
  }, [ isPermitted, setInitialPath, initialPath, pathname]);

  useEffect(() => {
    function handleQueryParams() {
      const query = qs.parse(search.split('?')[1]);
      if (query.layout) {
        changeNavStyle(query.layout as NavStyle);
      }
      if (query.mode) {
        updateThemeMode(query.mode as ThemeMode);
      }
      if (query.rtl) {
        setRTL(true);
      }
      if (query.style) {
        updateThemeStyle!(query.style as ThemeStyle);
      }
    }

    if (search) {
      handleQueryParams();
    }
  }, [changeNavStyle, updateThemeMode, setRTL, updateThemeStyle, search]);

  useEffect(() => {
    if (!loading) {

      
 let practitionerDetails = localStorage.getItem('PractitionerDetails');
      let token = '';

      if (practitionerDetails) { 
        let userdetails = JSON.parse(practitionerDetails);
         token = userdetails['identificationKey'];
      }

/*
      if (!user && !isPermitted) {

        console.log("before logoin1");
        history.push('/login'); // allowed route

      } else if (user && !isPermitted) {
        console.log("before logoin2");
        history.push('/error-pages/error-404'); // Not found
      } else if (user && isPermitted) {
        console.log("before logoin");
        if (
          pathname === '/' ||
          pathname === '/login' 
        ) {
          history.push(initialUrl);
        } else {
          // @ts-ignore
          if (
            initialPath &&
            initialUrl !== initialPath &&
            initialPath !== '/'
            // initialPath !== '/login' ||
            // initialPath !== '/signup')
          ) {
            history.push(initialPath);
          }
        }
      }*/

if (!token) {

        // console.log("before logoin1");
       // history.push('/login'); // allowed route

  
        if (
          pathname === "/login" ||
          pathname === "/reset-password" ||
          pathname === "/verification" ||
          pathname === "/forgot-password" ||
          pathname === "/external_video_consultation/join"
        ) {
          if (pathname === "/external_video_consultation/join"){
            history.push(pathname+search);
          }else{
            history.push(pathname);
          }
        } else {
          history.push("/login");
  }
  
      } else if (token) {
        // console.log("before logoin");
        if (
          pathname === '/' ||
          pathname === '/login' ||
          pathname === "/reset-password" ||
          pathname === "/verification" ||
          pathname === "/forgot-password"
        ) {
          history.push(initialUrl);
        } else {
          // @ts-ignore
          if (
            initialPath &&
            initialUrl !== initialPath &&
            initialPath !== '/'
            // initialPath !== '/login' ||
            // initialPath !== '/signup')
          ) {
            history.push(initialPath);
          }
        }
      }


    }


  }, [user, loading, initialPath, isPermitted, pathname, history]);

  return loading ? <Loader /> : <>{children}</>;
};

export default AuthRoutes;
